/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Promote_UserInputs */

const en_admin_create_promote_user = /** @type {(inputs: Admin_Create_Promote_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promote this user to admin`)
};

const de_admin_create_promote_user = /** @type {(inputs: Admin_Create_Promote_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Nutzer zum Admin machen`)
};

/**
* | output |
* | --- |
* | "Promote this user to admin" |
*
* @param {Admin_Create_Promote_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_promote_user = /** @type {((inputs?: Admin_Create_Promote_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Promote_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_promote_user(inputs)
	return en_admin_create_promote_user(inputs)
});